// src/components/admin/scheduling/components/SubjectSelect.js
import React, { useState, useEffect, useRef, useMemo } from "react";
import { fetchSubjects,  } from "../schedulingApi";
import "./Modal.css";

export default function SubjectSelect({
  value,
  onChange,
  disabled = false,
  inputClassName = "input",
  style,
  placeholder = "Type to search subject...",
}) {
  const [subjects, setSubjects] = useState([]);
  const [search, setSearch] = useState(value || "");
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    let alive = true;
    fetchSubjects().then((data) => {
      if (alive) setSubjects(data);
    });
    return () => { alive = false; };
  }, []);

  useEffect(() => {
    setSearch(value || "");
  }, [value]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filtered = useMemo(() => {
    if (!search) return subjects;
    return subjects.filter((s) => s.name.toLowerCase().includes(search.toLowerCase()));
  }, [subjects, search]);

  const handleSelect = (name) => {
    if (disabled) return;
    onChange(name);
    setSearch(name);
    setIsOpen(false);
  };

  const typed = search.trim();
  // Offer the raw typed value as a choice so admins can keep a custom subject
  // that isn't in the scheduler's subject list yet.
  const showUseTyped = typed.length > 0 && !subjects.some((s) => s.name.toLowerCase() === typed.toLowerCase());

  return (
    <div style={{ position: "relative" }} ref={wrapperRef}>
      <input
        type="text"
        className={inputClassName}
        value={search}
        placeholder={placeholder}
        onChange={(e) => {
          if (disabled) return;
          setSearch(e.target.value);
          onChange(e.target.value);
          setIsOpen(true);
        }}
        // ✅ CHANGED: Toggle behavior on click
        onClick={(e) => {
          if (disabled) return;
          e.stopPropagation(); // Prevent modal background click logic
          setIsOpen((prev) => !prev);
        }}
        disabled={disabled}
        style={
          disabled
            ? { ...style, backgroundColor: "#f5f5f5", cursor: "not-allowed", color: "#555" }
            : style
        }
      />
      
      {isOpen && !disabled && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 200,
            background: "#fff",
            border: "1px solid #e2e8f0",
            borderRadius: 8,
            boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
            maxHeight: 200,
            overflowY: "auto",
            marginTop: 4,
          }}
        >
          {showUseTyped && (
            <div
              style={{
                padding: "8px 12px",
                fontSize: 13,
                cursor: "pointer",
                color: "#4338ca",
                fontWeight: 600,
                borderBottom: "1px solid #f1f5f9",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.background = "#eef2ff"; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
              onClick={() => handleSelect(typed)}
            >
              Use “{typed}”
            </div>
          )}
          {filtered.map((s) => (
            <div
              key={s.id}
              style={{ padding: "8px 12px", fontSize: 13, cursor: "pointer", color: "#0f172a" }}
              onMouseEnter={(e) => { e.currentTarget.style.background = "#f0f9ff"; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
              onClick={() => handleSelect(s.name)}
            >
              {s.name}
            </div>
          ))}
          {filtered.length === 0 && !showUseTyped && search.trim().length === 0 && (
            <div style={{ padding: "8px 12px", fontSize: 13, color: "#94a3b8" }}>
              Start typing…
            </div>
          )}
          {filtered.length === 0 && !showUseTyped && search.trim().length > 0 && (
            <div style={{ padding: "8px 12px", fontSize: 13, color: "#94a3b8" }}>
              No subjects found
            </div>
          )}
        </div>
      )}
    </div>
  );
}
